import React, { Component } from 'react'
import PropTypes from 'prop-types'
import getBoxStatus from "../../../vietnameses/getBoxStatus"
import classNames from 'classnames'
import NextBoxFBAInput from "./NextBoxFBAInput";
import NextBoxFBAPrintQR from "./NextBoxFBAPrintQR";
import parseBoxStatistics from "../helpers/parseBoxStatistics"
import CloseBox from './CloseBox';

class NextBoxFBAHeader extends Component {
    _parseStatistics = () => {
        const { items } = this.props

        return parseBoxStatistics(items)
    }

    render() {
        const { box, onRefresh, indexBoxClosed, onUpdateLocalStore, barcodeError, onClose, closeBlockedReason, closeConfirmWarning } = this.props
        const { id, status, total_items, total_packages, name, warehouse } = box
        const statusText = getBoxStatus(status)
        const statistics = this._parseStatistics()

        return (
            <div className={classNames("NextBoxHeader card-header border-bottom", status)}>
                <h1 className="d-flex justify-content-between">
                    <div className="Left">
                        <span className="Name">Thùng FBA số #{id}</span>
                        <span> - </span>
                        <span>{total_items || 0} sản phẩm</span>
                        <span>  |  </span>
                        <span>{total_packages || 0} gói</span>
                        {name && (
                            <>
                                <span>  -  </span>
                                <span>{name || ''}{!!warehouse && `(${warehouse})`}</span>
                            </>
                        )}
                    </div>

                    <div className="Right d-flex align-middle">
                        <div className="d-flex">
                            <CloseBox
                                barcodeError={barcodeError}
                                onClose={onClose}
                                box={box}
                                position='header'
                                disabledReason={closeBlockedReason}
                                confirmWarning={closeConfirmWarning}
                            />
                            <NextBoxFBAPrintQR box={box} indexBoxClosed={indexBoxClosed} statistics={statistics} />

                            <div className="StatusText ml-2">
                                {statusText}
                            </div>
                        </div>
                    </div>
                </h1>

                <NextBoxFBAInput onUpdateLocalStore={onUpdateLocalStore} onRefresh={onRefresh} box={box} />
            </div>
        )
    }
}

NextBoxFBAHeader.propTypes = {
    box: PropTypes.object.isRequired,
    onRefresh: PropTypes.func.isRequired,
    indexBoxClosed: PropTypes.number
}

export default NextBoxFBAHeader
